import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_NOTE_STUDENT_COMPLETE_CLASS } from "../Schema/Class";

const useNoteStudentCompleteClass = (variables) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState({});

  // console.log("variables:", variables);
  const { refetch } = useQuery(GET_NOTE_STUDENT_COMPLETE_CLASS, {
    variables: variables,
    onCompleted: ({ getNoteStudentCompleteByEnrollment }) => {
      // console.log("getNoteStudentCompleteByEnrollment :" , getNoteStudentCompleteByEnrollment)
      setTableData(getNoteStudentCompleteByEnrollment);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading, refetch };
};

export default useNoteStudentCompleteClass;
